import CryptoJS from 'crypto-js'
const key = 'gagc#2017ABCDgagc#2017ABCD';
const iv = '01234567';
class DES3 {
	static options(vi) {
		const iv = CryptoJS.enc.Utf8.parse(vi);
		const options = {
			iv,
			padding: CryptoJS.pad.Pkcs7,
			mode: CryptoJS.mode.CBC
		};
		return options;
	}
	/**
	 *初始向量iv必须要CryptoJS.Utf8编码parse一下。
	 *加解密用的key也需要用CryptoJS.Utf8编码parse一下。
	 *加密后的对象要调用toString方法，否则返回的是CryptoJS库中的一个对象。
	 */
	static encrypt(plaintext) {
		const utf8Key = CryptoJS.enc.Utf8.parse(key);
		const encrypted = CryptoJS.TripleDES.encrypt(plaintext, utf8Key, this.options(iv));
		return encrypted.toString();
	}
	/**
	 *解密时，加密后的字符串( secret )不需要做base64的decode，直接用base64 encode过的字符串即可。这点和Java相关的API不太一样。
	 *解密后的对象要用CryptoJS.Utf8 stringify一下来返回最终的字符串。
	 */
	static decrypt(secret) {
		const utf8Key = CryptoJS.enc.Utf8.parse(key);
		const decrypted = CryptoJS.TripleDES.decrypt(secret, utf8Key, this.options(iv));
		return CryptoJS.enc.Utf8.stringify(decrypted);
	}
}
export {
	DES3,
	key
}



// WEBPACK FOOTER //
// ./src/utils/crypto-js.js